<template>
    <div class="register_form">
        <div v-if="register_step == 1">
            <h5>注册</h5>
            <div class="type_select">
                <!-- <div :class="{ active: registerForm.type == 1 }" @click="registerForm.type = 1;">个人入驻</div> -->
                <!-- <div :class="{ active: registerForm.type == 2 }" @click="registerForm.type = 2;">企业入驻</div> -->
                <div :class="{ active: registerForm.type == 1 }" @click="registerForm.type = 1;">
                    <img src="@/assets/imgs/login_btn_1.png" alt="">
                    <span>个人入驻</span>
                </div>
                <div :class="{ active: registerForm.type == 2 }" @click="registerForm.type = 2;">
                    <img src="@/assets/imgs/login_btn_2.png" alt="">
                    <span>企业入驻</span>
                </div>
            </div>
            <van-button block type="primary" @click="register_step = 2;" style="background-color: #726FF9;">
                注册
            </van-button>
        </div>
        <div v-else>
            <h5>{{ registerForm.type == 1 ? '个人注册' : '企业注册' }}</h5>
            <div class="avatar"
                :style="{ backgroundImage: registerForm.avatar ? 'url(' + registerForm.avatar + ')' : '' }">
                <van-icon name="plus" size="30rem" v-if="!registerForm.avatar"></van-icon>
                <input type="file" accept="image/*" @change="uploadCover" />
            </div>
            <van-form @submitsubmit="onSubmit">
                <van-cell-group inset>
                    <van-field v-model="registerForm.name" name="name" placeholder="请输入用户名称"
                        :rules="[{ required: true, message: '请填写用户名' }]" />
                    <van-field v-model="registerForm.enterTypeLabel" readonly name="picker" placeholder="请选择企业类型" @click="showPicker = true"
                        :rules="[{ required: true, message: '请选择企业类型' }]" v-if="registerForm.type == 2" />
                    <van-field v-model="registerForm.password" type="password" name="password" placeholder="请输入密码(6-20个大小写英文字母、数字、字符"
                        :rules="[{ required: true, message: '请输入密码(6-20个大小写英文字母、数字、字符)' }]" />
                    <van-field v-model="registerForm.mobile" name="mobile" placeholder="手机号码"
                        :rules="[{ required: true, message: '请输入您的手机号码' }]" />

                    <div class="code_row">
                        <van-row>
                            <van-col span="16">
                                <van-field v-model="registerForm.code" name="code" placeholder="请输入验证码"
                                    :rules="[{ required: true, message: '请填写验证码' }]" />
                            </van-col>
                            <van-col span="8">
                                <button class="code_btn" @click.stop="sendCode(registerForm.mobile)"
                                    v-if="remainSecond <= 0">获取验证码</button>
                                <button class="code_btn" v-else>{{ remainSecond }}秒后获取</button>
                            </van-col>
                        </van-row>
                    </div>
                </van-cell-group>
                <p class="info">
                    <van-checkbox v-model="registerForm.agree" name="agree" shape="square" icon-size="18rem"
                        style="margin-right: 5rem;" />
                    我已阅读并同意 <span style="color: #726FF9;" @click="showAgreement">《九色文化用户协议》</span>
                </p>
                <van-button block type="primary" :disabled="!registerForm.agree" native-type="submit" style="background-color: #726FF9;" @click="confirm">注册</van-button>
            </van-form>
        </div>
        <p style="font-size: 14rem; color: #726FF9; margin-top: 20rem; text-align: center;" @click="emit('login')">
            已有账号，直接登录</p>
    </div>
    <van-popup v-model:show="showPicker" destroy-on-close position="bottom">
        <van-picker :columns="enterTypes" :model-value="pickerValue" @confirm="onConfirm"
            @cancel="showPicker = false" />
    </van-popup>
</template>

<script setup>
import { ref, onMounted, reactive, toRaw } from 'vue'
import { http } from '@/request/http'
import { client } from '@/request/oss';
import { sendCode, remainSecond, clearTimer } from '@/utils/codeSender'
import { showConfirmDialog } from 'vant';
import cookie from 'cookie.js';
const emit = defineEmits(['login'])
const enterTypes = ref([])

const isRegister = ref(false)
const showPicker = ref(false)
const pickerValue = ref([])
const registerForm = reactive({
    name: '',
    avatar: '',
    password: '',
    mobile: '',
    code: '',
    type: 1,  //1个人  2企业
    enterType: '',
    enterTypeLabel: '',
    socialType: '',
    socialCode: '',
    socialState: '',
    agree: false,
})
const register_step = ref(1)



onMounted(() => {
    http.get('/app-api/system/dict-data/type?type=enter_type').then(res => {
        enterTypes.value = res.map(item => {
            return {
                text: item.label,
                value: item.value,
            }
        })
    })
})

const onConfirm = ({ selectedValues, selectedOptions }) => {
    registerForm.enterType = selectedOptions[0]?.value
    registerForm.enterTypeLabel = selectedOptions[0]?.text
    pickerValue.value = selectedValues
    showPicker.value = false
}

const uploadCover = e => {
    const file = e.target.files[0]
    const extName = file.name.slice(file.name.lastIndexOf('.'))
    client.setBucket('dfsk-3d')
    client.put(`cover/${Date.now() + extName}`, file).then(result => {
        registerForm.avatar = result.url
    })
}

function confirm(){
    http.post('/app-api/member/auth/register', {
        ...toRaw(registerForm)
    }).then(res => {
        if (res.accessToken) {
            cookie.set('accessToken', res.accessToken, { path: '/' })
            cookie.set('tenantId', res.tenantId, { path: '/' })
            //设置完 cookie 需要刷新页面才会生效，因此需要跳转的方式
            const path = route.query.path ? decodeURIComponent(route.query.path) : '/'
            window.location.href = path
            clearTimer()
        }
    })
}


const showAgreement = () => {
    showConfirmDialog({
        title: '博览中国用户协议',
        message: `
        欢迎使用博览中国！
        为使用博览中国服务（可简称“本服务”），您应当阅读并遵守《博览中国服务协议》（以下简称:本协议）。请您务必审慎阅读、充分理解各条款内容，特别是 限制或免除责任的条款，以及开通或使用某项服务的单独协议、规则。限制或免责条款可能以加粗或加下划线的形式提示您重点注意。
        除非您已阅读并接受本协议及相关协议、规则等的所有条款，否则，您无权使用本服务。一旦您选择“同意协议并提交”（具体措辞详见注册页面）并完成 注册流程，或您以任何方式使用本服务，即视为您已阅读并同意上述协议、规则等的约束。
        您有违反本协议的任何行为时，星汉云有权依照本协议根据您违反情况，随时单方采取限制、中止或终止向您提供服务等措施，并有权追究您的相关责任。
        第一条 通则
        1.1 博览中国服务指为满足各类网站、应用等各种产品/服务的不同需求，由计算处理与网络、存储与 CDN、云数据库、云安全、监控与管理、域名服务、
        1.2 博览中国服务的种类、服务标准、使用规则、结算方式（包括但不限于预付费、后付费等，下同）及计费标准等统称“服务规则”，以星汉云官网（网址： dw.3ddwh.cn，下同）及购买具体服务时的页面说明为准，本协议或双方另有约定除外。
        1.3 东方金典数字科技（湖南）有限公司（以下简称东方数科）有权随时对星汉云服务规则进行调整，并通过网站公告、邮件通知、短信通知等方式予以公布，而无需另行获得您同意。
        1.4 东方数科仅向您提供基于计算机的云系统算力服务等各类技术服务，是中立的信息存储空间等网络服务及相关的中立技术支持服务提供者(具体服务请 参阅网站介绍内相关页面)。您的网站、应用等任何产品、服务及相关内容等，由您自行开发、运营，且自行承担全部责任。
        1.5 双方均保证已经依照国家相关规定获得了合法经营资质，有权依法运营其产品及服务。您应按国家及地方要求对接入网站进行备案，否则，东方数科有 权根据国家法律法规拒绝提供网络接入等服务。
        第二条 账户
        2.1 您可以使用手机号码等博览中国服务支持的方式，按照博览中国官网注册页面提示完成注册流程，并获得博览中国服务账户（简称“博览中国账户”）。
        2.2 您若使用关联帐号注册，为保护星汉云账户的安全性和独立性，您应当在注册过程中关联手机号码，以用于星汉云服务的相关操作。
        2.3 您应当按照博览中国服务注册流程填写、提交真实、合法、有效的资料（统称“资料”），根据您对产品及服务的需求，包括但不限于名称、联系人、电子 邮箱、联系电话、联系地址、工商登记证件等；如果资料发生变更的，您应及时根据星汉云系统的规则自行进行更新。
        2.4 本协议效力适用于您名下全部博览中国账户。博览中国账户将作为您使用星汉云服务的身份识别依据，您应当对博览中国账户采取必要、有效的保密措施，并 为您博览中国账户下的一切行为负责。
        2.5 为保护账户和交易安全，东方数科有权随时要求您进行实名认证，您应当予以配合。您同意授权东方数科可以通过向第三方核实您的身份和资格等信息 的方式，对您进行认证及取得您使用本服务所需的相关资料。
        2.6 实名认证是对博览中国账号归属进行判断的一个依据，且账户申请提现及获取发票时将以实名认证对应的主体为准，请您在做认证时务必谨慎对待，给与 足够的重视并理解、遵守以下规则：
        2.6.1 须确保认证主体与账号使用主体保持一致，避免将企业使用的账户认证在个人名下，或将本人使用的博览中国账户认证在他人名下等任何不当认证行为。
        `
    }).then(() => {
        registerForm.agree = true
    })
}
</script>
<style lang="scss" scoped>
.register_form {
    .type_select {
        display: flex;
        justify-content: space-around;
        margin: 30rem 0;

        >div {
            width: 160rem;
            height: 148rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border: 1px solid #D8DAE6;
            border-radius: 5rem;

            img {
                width: 100rem;
                height: 100rem;
            }

            span {
                color: #666666;
            }
        }

        .active {
            border-color: #726FF9;
            color: #fff;
        }
    }

    h5 {
        font-size: 18rem;
        text-align: center;
        font-weight: normal;
    }

    .avatar {
        width: 88rem;
        height: 88rem;
        background-color: #F2F2F2;
        border-radius: 50%;
        margin: 20rem auto;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-size: 100% 100%;

        input {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }

    .info {
        font-size: 12rem;
        color: #999999;
        margin: 10rem 0;
        display: flex;
    }

    ::v-deep(.van-cell-group) {
        background-color: transparent !important;
        margin: 0;

        .van-cell {
            background: transparent !important;
            padding: 10rem 0;

            .van-field__control {
                background-color: transparent !important;
                height: 42rem !important;
                line-height: 42rem;
                border: 1px solid #D8DAE6;
                padding: 0 10rem;
                border-radius: 3rem;
            }
        }
    }

    .code_row {
        width: 100%; margin-bottom: 10rem;
        ::v-deep(.van-cell) {
            padding: 0 !important;
            .van-field__control {
                padding: 0 10rem;
                border-radius: 3rem 0 0 3rem;
            }
        }
        .code_btn{
            margin: 0;
            border-radius: 0 3rem 3rem 0;
            border: 1px solid #D8DAE6;
            border-left: none;
        }
    }

    .code_btn {
        margin: 10rem 0;
        height: 42rem;
        border: none;
        width: 100%;
        background-color: #F8F8F8;
        color: #999999;
    }
}
</style>